import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pauseSchedule } from '@/features/accounts/api';

export function usePauseSchedule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: pauseSchedule,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['schedules'] }),
  });
}
